import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Challenges…',
  slug: 'challenges',
  category: 'Challenges',
  date: '2025-05-16',
  image: '',
  excerpt: 'Climb that mountain. Survive the river\'s rapids. Walk that tightrope and get to the other side.',
  body: `There are different kinds of challenges.

- Some are mountains to climb, requiring effort, perseverance, and dedication.
- Some are like being in the rapids where skills and adaptability is tested.
- Some are like walking a tightrope, requiring balance and steady footing.

Regardless of the metaphor, it could be helpful to work with someone to set up how you approach the challenge. Outside perspective can make all the difference.`,
}

export default post
